import { Box, CircularProgress } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ScheduleWeeks } from "@/hooks/useScheduleWeeks";
import { SystemBanner } from "@/ui/molecules/SystemBanner";
import SystemButton from "@/ui/SystemButton/SystemButton";

type Props = { load: Pick<ScheduleWeeks, "isLoading" | "isError" | "refetch">; errorTitle: string; dataTestId: string };

/** A spinner while schedule data loads, `errorTitle` with Retry when it fails, and nothing once it's in. */
export const ScheduleLoadFallback: FC<Props> = ({ load, errorTitle, dataTestId }) => {
	const { t } = useTranslation();
	if (load.isLoading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", p: 4 }} data-testid={`${dataTestId}-loading`}>
				<CircularProgress />
			</Box>
		);
	}
	if (!load.isError) return null;
	return (
		<SystemBanner
			tone="error"
			title={errorTitle}
			action={
				<SystemButton buttonVariant="secondary" size="small" onClick={load.refetch} data-testid={`${dataTestId}-retry`}>
					{t("retry")}
				</SystemButton>
			}
			sx={{ m: 2 }}
			dataTestId={`${dataTestId}-error`}
		/>
	);
};
